import React from 'react';

const Incidents = (props) => {
    const { incidents, onChangeQualification, category, qualification } = props;

    return (
        <div className='col-6'>
            {
                incidents.map((incident, index) => (
                    incident.category === category && (
                        <div key={index} className='row'>
                            <div className='col-12'>
                                <div
                                    className={`text-center cursor-pointer 
                                        ${qualification === incident.reason ? 'bg-success text-light p-1 m-1 rounded' : 'm-1'}
                                    `}
                                    id={incident.id}
                                    onClick={() => onChangeQualification({ target: { id: 'qualification', value: incident.reason } })}
                                >
                                    {incident.reason}
                                </div>
                            </div>
                        </div>
                    )
                ))
            }
        </div>
    );
};

export default Incidents;
